import { LeadSequenceStatus } from '@crm/api'
import { createStyles, FullToken } from 'antd-style'

const statusDotColor: Record<LeadSequenceStatus, keyof FullToken> = {
  [LeadSequenceStatus.ACTIVE]: 'colorInfo',
  [LeadSequenceStatus.FAILED]: 'colorWarning',
  [LeadSequenceStatus.SUCCESS]: 'colorSuccess'
}

export const useStyles = createStyles(
  ({ token }, props?: { color?: LeadSequenceStatus }) => ({
    statusDot: {
      width: 6,
      height: 6,
      borderRadius: '100%',
      backgroundColor: props?.color
        ? (token[statusDotColor[props.color]] as string)
        : token.colorBgMask
    }
  })
)
